/**
 * 受注一覧 予約登録
 */
import Vue from 'vue'
import * as httpConst from '../../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/accepts/self_emissions/reservations`

 const orders_accepts_self_emission_reservation = {
  namespaced: true,
  actions: {
    /**
     * 排出持込 予約登録
     * 排出持込編集画面よるコール
     * @param commit
     * @param id { number } 排出持込ID
     * @param params
     * @return {Promise<unknown>}
     */
    update ({ commit }, { id, params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.put(`${API_PATH}/${id}`, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
 }

 export default orders_accepts_self_emission_reservation
